





















































import { Vue, Component } from 'vue-property-decorator';

import { namespace } from 'vuex-class';
import axios from 'axios';
import store from '../store';
import { SHOW_REQUEST_SUCCESS } from '@/store/constants/mutation-types';

@Component({})
export default class CustomerView extends Vue {
  public $auth!: {
    token: string;
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  private defaultRule = [(v: any) => !!v || 'Value Required'];

  private customerNameRule = [...this.defaultRule];
  private customerABNRule = [...this.defaultRule];

  @(namespace('CustomerModule').State('customers'))
  private customers!: object[];
  @(namespace('SuccessModule').Mutation(SHOW_REQUEST_SUCCESS))
  private showRequestSuccess!: () => void;
  @(namespace('CustomerModule').Action('getCustomers'))
  private getCustomers!: (accessToken) => void;
  @(namespace('CustomerModule').Action('createCustomer'))
  private createCustomer!: (payload) => void;
  @(namespace('CustomerModule').Action('updateCustomer'))
  private updateCustomer!: (payload) => void;
  @(namespace('CustomerModule').Action('deleteCustomer'))
  private deleteCustomer!: (payload) => void;

  private valid = false;
  private loading = true;

  private headers = [
    { text: 'Customer Name', value: 'name' },
    { text: 'Customer ABN', value: 'abn' },
    { text: 'Actions', value: 'action', sortable: false }
  ];

  private defaultCustomer = {
    name: '',
    abn: '',
    id: null
  };

  private editedCustomer = {
    name: '',
    abn: '',
    id: null
  };

  private dialog = false;
  private editedIndex = -1;
  private customerNameFieldDisabled = false;

  private async created() {
    this.getCustomers(this.$auth.token);
    this.loading = false;
  }

  private edit(customer: object) {
    this.customerNameFieldDisabled = true;
    this.editedIndex = this.customers.indexOf(customer);
    console.log(this.editedIndex);
    this.editedCustomer = Object.assign(this.editedCustomer, customer);
    console.log(this.editedCustomer);
    this.dialog = true;
  }

  private del(customer: object) {
    if (confirm('Are you sure you want to delete this customer?')) {
      const payload = {
        token: this.$auth.token,
        customer,
        index: this.customers.indexOf(customer)
      };
      this.deleteCustomer(payload);
    }
  }

  private async save(item) {
    if (this.$refs.form.validate()) {
      const payload = {
        token: this.$auth.token,
        customer: this.editedCustomer,
        index: this.editedIndex
      };
      if (this.editedIndex > -1) {
        this.updateCustomer(payload);
      } else {
        this.createCustomer(payload);
      }
      this.close();
    }
  }

  get formTitle() {
    return this.editedIndex === -1 ? 'New Customer' : 'Edit Customer';
  }
  private close() {
    this.dialog = false;
    this.customerNameFieldDisabled = false;
    this.editedCustomer = Object.assign({}, this.defaultCustomer);
    this.editedIndex = -1;
  }
}
